module.exports = __webpack_public_path__ + "media/flip.ff253bd4.mp3";